import { Menu, LogOut, Store } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const ROLE_LABELS = {
  superadmin: "Super Admin",
  admin: "Tenant Admin",
  shop_admin: "Shop Admin",
  staff: "Team Member",
};

export default function TopBar({ onMenuToggle, shop }) {
  const { logout, user } = useAuth();

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="menu-toggle" onClick={onMenuToggle} aria-label="Open menu" data-testid="menu-toggle-btn">
          <Menu size={16} />
        </button>
        <div>
          <div className="crumb">Kitchen Operations</div>
          <div className="top-title" data-testid="page-title">{ROLE_LABELS[user?.role] || "Team Member"}</div>
        </div>
      </div>
      <div className="top-actions">
        {shop && (
          <div className="open-state" data-testid="shop-open-state">
            <span />{shop.is_active ? "Counter open" : "Counter closed"}
          </div>
        )}
        {shop && (
          <div className="shop" data-testid="current-shop-name" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 28, height: 28, borderRadius: 8, background: "var(--teal-soft)", color: "var(--teal)", display: "grid", placeItems: "center", flex: "none" }}>
              <Store size={13} />
            </span>
            <span>
              <strong style={{ display: "block" }}>{shop.name}</strong>
              <small style={{ display: "block", color: "var(--fg-faint)", fontSize: 10 }}>Current assigned shop</small>
            </span>
          </div>
        )}
        <button className="btn btn-secondary btn-sm" onClick={logout} data-testid="logout-btn">
          <LogOut size={13} /> Logout
        </button>
      </div>
    </div>
  );
}
